/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const AgreementAction = {
  ActionAgree: "ACTION_AGREE",
  ActionAgreeRevoke: "ACTION_AGREE_REVOKE",
} as const;

export type AgreementAction =
  (typeof AgreementAction)[keyof typeof AgreementAction];

export type AgreementActionEnumType = typeof AgreementAction;
export type AgreementActionOptional = AgreementAction;
export type AgreementActionTrackedI = AgreementAction;
export type AgreementActionTracked = AgreementAction;
export type AgreementActionMetaI = EnumMetaType<
  AgreementActionEnumType,
  AgreementAction
>;
export const AgreementActionMeta = typeMetaEnum<
  AgreementActionEnumType,
  AgreementAction
>("AgreementAction", AgreementAction);
export function transformDatesAgreementAction(model: AgreementAction) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
